import React, { useLayoutEffect } from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { languageForLocale, SiteLocale } from "../i18n/localizedRoutes";
import { normalizeSiteLanguage } from "../i18n/language";

// The URL always wins over a saved preference on public content pages.
const LocalizedSite: React.FC<{ locale: SiteLocale }> = ({ locale }) => {
  const { i18n } = useTranslation();
  const language = languageForLocale(locale);
  const currentLanguage = normalizeSiteLanguage(i18n.resolvedLanguage || i18n.language);
  useLayoutEffect(() => {
    if (currentLanguage !== language) {
      void i18n.changeLanguage(language);
    }
  }, [i18n, language, currentLanguage]);
  if (currentLanguage !== language) return null;
  return <Outlet />;
};

export default LocalizedSite;
